import React from 'react';
import { RouteCard } from '@/components/dataDisplay/cards/RouteCard';

import { styles } from './styles';
import { Route } from '@/services/routes/route.vm';
import { generatePath, Link } from 'react-router';
import { routes as routingRoutes } from '@/constants/routes';
import Skeleton from '@/components/dataDisplay/Skeleton';

interface Props {
  routes: Route[];
  loading: boolean;
}

const AvailableRoutes: React.FC<Props> = ({ routes = null, loading }) => {
  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Rutas Fundamento</h2>
      <p style={styles.text}>
        Las rutas fundamentales te dan una base fuerte para conseguir un control de tus emociones y comenzar
        el viaje para cambiar tu vida.
      </p>
      <div style={styles.cardsContainer}>
        {loading && (
          <>
            <Skeleton width="100%" height="120px" borderRadius="8px" />
            <Skeleton width="100%" height="120px" borderRadius="8px" />
            <Skeleton width="100%" height="120px" borderRadius="8px" />
          </>
        )}
        {!loading &&
          routes?.map((item, index) => (
            <Link to={generatePath(routingRoutes.routes.detail, { routeId: item.id })} key={item.id}>
              <RouteCard
                routeNumber={item.order}
                progress={item.progress}
                backgroundImage={item.coverImage}
                title={item.title}
              />
            </Link>
          ))}
      </div>
    </div>
  );
};

export default AvailableRoutes;
